import React from 'react';
import { Link } from 'react-router-dom';

import { ACADEMY_URL, INSIGHTS_URL, CHANGELOG_URL } from '../../constants/app';
import { rootDomainUrl } from '../../utils/url';
import * as Content from '../../attrs/content';

import { getCurrentYear } from '../../utils/other';

import Icon from '../icon';

import { Container, Copyright, List, Item, IconsItem } from './style';

const Footer: React.FC = () => (
  <Container>
    <List>
      <Item>
        <Link to="/">Studio</Link>
      </Item>
      <Item>
        <a href={rootDomainUrl('/')}>Glassnode Home</a>
      </Item>
      <Item>
        <a href={INSIGHTS_URL}>Insights</a>
      </Item>
      <Item>
        <a href={ACADEMY_URL}>Academy</a>
      </Item>
      <Item>
        <Link to="/pricing">Pricing</Link>
      </Item>
      <Item>
        <a href={rootDomainUrl('/company')}>Company</a>
      </Item>
      <Item>
        <a href={rootDomainUrl('/contact')}>Contact</a>
      </Item>
      <Item>
        <a href={CHANGELOG_URL} rel="noopener noreferrer" target="_blank">
          Changelog
        </a>
      </Item>
      <Item>
        <a href={rootDomainUrl('/privacy-notice')}>Privacy Notice</a>
      </Item>
      <Item>
        <a href={rootDomainUrl('/terms-and-conditions')}>Terms &amp; Conditions</a>
      </Item>
      <Item>
        <a href={rootDomainUrl('/impressum')}>Impressum</a>
      </Item>
    </List>
    <List>
      <IconsItem>
        <a href={Content.twitterUrl} rel="noopener noreferrer" target="_blank">
          <Icon symbol="twitter" />
        </a>
      </IconsItem>
      <IconsItem>
        <a href={Content.telegramUrl} rel="noopener noreferrer" target="_blank">
          <Icon symbol="telegram" />
        </a>
      </IconsItem>
    </List>
    <Copyright>&copy; {getCurrentYear()} Glassnode. All Rights Reserved.</Copyright>
  </Container>
);

export default Footer;
